import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../constants';

/**
 * Hook that returns true when viewport width is below the given breakpoint.
 */
export const useBreakpoint = (breakpoint) => {
  const [matches, setMatches] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setMatches(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return matches;
};

/**
 * Convenience hook with common breakpoints.
 * @returns {{ isMobile: boolean, isTiny: boolean }}
 */
export const useIsMobile = () => {
  const [screenSize, setScreenSize] = useState({
    isMobile: window.innerWidth < BREAKPOINTS.TABLET,
    isTiny: window.innerWidth < BREAKPOINTS.TINY,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        isMobile: window.innerWidth < BREAKPOINTS.TABLET,
        isTiny: window.innerWidth < BREAKPOINTS.TINY,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
